import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Browser-local workspace id for v1 (no auth yet).
function getWorkspace() {
  let ws = localStorage.getItem("qt_workspace");
  if (!ws) {
    ws = "ws_" + Math.random().toString(36).slice(2, 12);
    localStorage.setItem("qt_workspace", ws);
  }
  return ws;
}

const client = axios.create({ baseURL: API_BASE, timeout: 60000 });
client.interceptors.request.use((cfg) => {
  cfg.headers["X-Workspace"] = getWorkspace();
  return cfg;
});

export const api = {
  listChains:        ()                        => client.get("/chains").then((r) => r.data.chains),
  scan:              (chain, address)          => client.post("/scan", { chain, address }).then((r) => r.data),
  analyzeContract:   (payload)                 => client.post("/contract/analyze", payload).then((r) => r.data),
  fetchContractSrc:  (chain, address)          => client.post("/contract/fetch-source", { chain, address }).then((r) => r.data),
  workspace:         ()                        => client.get("/atlas/workspace").then((r) => r.data),
  report:            (id)                      => client.get(`/report/${id}`).then((r) => r.data),
};

// Underlying axios instance for callers that need raw .get/.post against
// the API base (e.g. nudge-experiment endpoints in Scan.jsx).
export const apiClient = client;

export default api;
